// Utils
import cn from '@/utils/cn';
// Styles
import styles from './InputWrapper.module.css';

interface InputWrapperProps {
  children: React.ReactNode;
  error?: string;
  inputClassName?: string;
  disabled?: boolean;
}

function InputWrapper({ error = '', children, inputClassName = '', disabled = false }: InputWrapperProps) {
  return (
    <div
      className={cn([
        styles.input,
        error ? styles['with-error'] : '',
        inputClassName || '',
        disabled ? styles.disabled : '',
      ])}
    >
      {children}

      {error && <p className={styles.error}>{error}</p>}
    </div>
  );
}

export default InputWrapper;
